import React from 'react';

/**
 * Ideal Body Weight Output component
 */
const IdealBodyWeightOutput = (props) => {

  const {images} = props.data;
  const {selectedBCS, species} = props;

  if (!species || !images){
    return null;
  }

  let displayImage = images[species][selectedBCS - 1];

  return (
    <div className="nppe2-fc-body-condition-output">
      <img className="img-responsive" src={displayImage?.imagePath} alt={displayImage?.imageAltText}/>
      <p>{props.text}</p>
    </div>
  );
};

export default IdealBodyWeightOutput;
